import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !key) {
  throw new Error(
    "[DKER] VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY doivent être définies. " +
      "Copier .env.example en .env.local et remplir avec les clés du projet Supabase.",
  );
}

export const supabase = createClient(url, key, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: "pkce",
  },
  realtime: { params: { eventsPerSecond: 5 } },
});
